import React, { Component } from 'react'
import ListingPage from '../../../containers/ListingPage'
import { APG_GATEWAY_HOST } from 'config/app'
import { Row, Cell } from '../../../components/Table'
import SingleDatePickerWrapper from '../../../components/SingleDatePickerWrapper'
import exportFromJSON from 'export-from-json'
import { Popup } from '../../../components/Popup'
import Upload from '../../../components/FileUpload'
import API from '../../../lib/api'
import moment from 'moment'
import Papa from 'papaparse'
import * as XLSX from 'xlsx'
import toast, { Toaster } from 'react-hot-toast'
import './style.css'

const API_DATE_FORMAT = 'YYYY-MM-DDTHH:mm:ssZ'

const emptyState = {
    message: 'No records found',
}

export default class Transporter extends Component {
    constructor(props) {
        super(props)
        // Read 'd' from URL query params (fallback to 'pickupDate'), fallback to today's date
        const urlParams = new URLSearchParams(window.location.search)
        const dateFromUrl = urlParams.get('d') || urlParams.get('pickupDate')
        // Clean up: ensure only YYYY-MM-DD
        const cleanDateFromUrl = dateFromUrl ? dateFromUrl.split(' ')[0].split('T')[0].substring(0, 10) : null
        const today = new Date().toISOString().split('T')[0]
        this.state = {
            pickupDate: cleanDateFromUrl || today,
            selectedRows: [],
            showBulkUploadModal: false,
            showAssignTransporterModal: false,

            transporterId: '',
            drivers: [],
            loadingDrivers: false, // Added loading state for drivers
            data: [],
            refreshCounter: 0,
        }
    }

    componentDidMount() {
        this.isMountedFlag = true
    }

    componentWillUnmount() {
        this.isMountedFlag = false
    }

    handleShowBulkUploadModal = () => {
        this.setState({ showBulkUploadModal: true })
    }

    handleHideBulkUploadModal = () => {
        this.setState({ showBulkUploadModal: false })
    }

    handleShowAssignTransporterModal = () => {
        this.setState({ showAssignTransporterModal: true })
        this.fetchDrivers()
    }

    fetchDrivers = () => {
        this.setState({ loadingDrivers: true })
        const api = new API({
            url: `${APG_GATEWAY_HOST}/seller-order-service/tracking-labels/drivers`
        })
        api.get({})
            .then(response => {
                const driverData = response.data || (Array.isArray(response) ? response : [])
                if (driverData && driverData.length > 0) {
                    // Extract unique drivers based on driverID
                    const uniqueDrivers = []
                    const map = new Map()
                    for (const item of driverData) {
                        if (item.driverID && !map.has(item.driverID)) {
                            map.set(item.driverID, true)
                            uniqueDrivers.push(item)
                        }
                    }
                    if (this.isMountedFlag) {
                        this.setState({ drivers: uniqueDrivers, loadingDrivers: false })
                    }
                } else {
                    if (this.isMountedFlag) {
                        this.setState({ loadingDrivers: false })
                    }
                }
            })
            .catch(error => {
                console.error('Error fetching drivers:', error)
                if (this.isMountedFlag) {
                    this.setState({ loadingDrivers: false })
                }
            })
    }

    handleHideAssignTransporterModal = () => {
        this.setState({ showAssignTransporterModal: false, transporterId: '' })
    }

    handleTransporterIdChange = (e) => {
        this.setState({ transporterId: e.target.value })
    }

    handleSubmitAssignTransporter = () => {
        const { transporterId, selectedRows, data, drivers } = this.state
        if (!transporterId) {
            toast.error('Please select a transporter')
            return
        }

        const selectedDriver = drivers.find(d => d.driverID === transporterId)
        const driverName = selectedDriver ? (selectedDriver.driverName || selectedDriver.driverID) : transporterId

        const payloadDrivers = data
            .filter(row => selectedRows.includes(row.id))
            .map(row => ({
                storeCode: String(row.storeCode || ''),
                vendorCode: parseInt(row.vendorCode, 10) || 0,
                driverID: transporterId,
                driverName: driverName,
                pickDate: moment(row.pickupDate).format(API_DATE_FORMAT),
            }))

        const api = new API({
            url: `${APG_GATEWAY_HOST}/seller-order-service/tracking-labels/drivers`
        })

        toast.promise(
            api.post({ drivers: payloadDrivers }),
            {
                loading: 'Assigning transporter...',
                success: 'Transporter assigned successfully',
                error: (err) => err.message || 'Failed to assign transporter'
            }
        ).then(() => {
            if (this.isMountedFlag) {
                this.setState({
                    showAssignTransporterModal: false,
                    transporterId: '',
                    selectedRows: [],
                    refreshCounter: this.state.refreshCounter + 1,
                })
            }
        }).catch(err => {
            console.error('Error assigning transporter:', err)
        })
    }

    handleRowSelect = (id) => {
        const { selectedRows } = this.state
        if (selectedRows.includes(id)) {
            this.setState({ selectedRows: selectedRows.filter(rowId => rowId !== id) })
        } else {
            this.setState({ selectedRows: [...selectedRows, id] })
        }
    }

    handleSelectAll = (checked) => {
        if (checked) {
            this.setState({ selectedRows: this.state.data.map(row => row.id) })
        } else {
            this.setState({ selectedRows: [] })
        }
    }

    handleDownloadTemplate = () => {
        const { pickupDate } = this.state
        const data = [{ 'Store Code': '', 'Vendor Code': '', 'Transporter ID': '', 'Date': pickupDate }]
        const fileName = `Transporter_Allocation_Template_${pickupDate}`
        exportFromJSON({ data, fileName, exportType: exportFromJSON.types.xls })
    }

    getTableProperties = () => {
        const { selectedRows } = this.state
        return {
            headers: [
                <div className="checkbox-wrapper" key="select-all">
                    <input
                        id="select-all"
                        type="checkbox"
                        checked={this.state.data.length > 0 && selectedRows.length === this.state.data.length}
                        onChange={(e) => this.handleSelectAll(e.target.checked)}
                    />
                    <label htmlFor="select-all" />
                </div>,
                'Picklist Number',
                'Vendor Code/Vendor Name',
                'Store Code/Delivery Address',
                'Pickup Date',
                'Handling Time',
                'Assigned Transporter',
            ],
            row: ({
                id,
                vendorCode,
                vendorName,
                storeCode,
                deliveryAddress,
                pickupDate,
                handlingTime,
                assignedTransporter,
            }) => (
                <Row>
                    <Cell>
                        <input
                            id={`checkbox-${id}`}
                            type="checkbox"
                            checked={selectedRows.includes(id)}
                            onChange={() => this.handleRowSelect(id)}
                        />
                        <label htmlFor={`checkbox-${id}`} />
                    </Cell>
                    <Cell>
                        <span>{id}</span>
                    </Cell>
                    <Cell>
                        <div className="cell-text-bold">{vendorCode}</div>
                        <div>{vendorName}</div>
                    </Cell>
                    <Cell>
                        <div className="cell-text-bold">{storeCode}</div>
                        <div>{deliveryAddress}</div>
                    </Cell>
                    <Cell>
                        <span>{pickupDate}</span>
                    </Cell>
                    <Cell>
                        <span>{handlingTime}</span>
                    </Cell>
                    <Cell>
                        <span>{assignedTransporter}</span>
                    </Cell>
                </Row>
            ),
        }
    }

    handleBulkUpload = (file) => {
        return new Promise((resolve, reject) => {
            const fileName = file.name || ''
            const extension = fileName.split('.').pop().toLowerCase()

            const processData = (data) => {
                const drivers = data.map((row) => {
                    const getValue = (possibleKeys) => {
                        const key = Object.keys(row).find(k =>
                            possibleKeys.some(pk => pk.toLowerCase() === k.trim().toLowerCase())
                        )
                        return key ? row[key] : undefined
                    }

                    const pickDateRaw = getValue(['pickDate', 'Pick Date', 'Pickup Date', 'pickupDate', 'Date'])
                    const transporterIdValue = getValue(['driverID', 'Driver ID', 'Transporter ID', 'transporterId']) || ''

                    let pickDate = ''
                    if (typeof pickDateRaw === 'number') {
                        // Convert Excel serial date to JS date
                        const date = new Date(Math.round((pickDateRaw - 25569) * 86400 * 1000))
                        // Add buffer and snap to start of day to avoid timezone/precision shifts
                        pickDate = moment(date).add(12, 'hours').startOf('day').format(API_DATE_FORMAT)
                    } else if (pickDateRaw) {
                        // Handle date strings or Date objects similarly
                        pickDate = moment(pickDateRaw).add(12, 'hours').startOf('day').format(API_DATE_FORMAT)
                    }

                    return {
                        storeCode: String(getValue(['storeCode', 'Store Code', 'Store ID', 'StoreName']) || ''),
                        vendorCode: parseInt(getValue(['vendorCode', 'Vendor Code']), 10) || 0,
                        driverID: transporterIdValue,
                        driverName: transporterIdValue,
                        pickDate: pickDate,
                    }
                })

                const api = new API({
                    url: `${APG_GATEWAY_HOST}/seller-order-service/tracking-labels/drivers`
                })

                return api.post({ drivers })
            }

            if (extension === 'csv') {
                Papa.parse(file, {
                    header: true,
                    skipEmptyLines: true,
                    complete: (results) => {
                        processData(results.data)
                            .then(() => {
                                toast.success('Drivers assigned successfully')
                                this.handleHideBulkUploadModal()
                                if (this.isMountedFlag) {
                                    this.setState({ refreshCounter: this.state.refreshCounter + 1 })
                                }
                                resolve()
                            })
                            .catch((err) => {
                                toast.error(err.message || 'Failed to assign drivers')
                                reject(err)
                            })
                    },
                    error: (err) => {
                        toast.error(err.message || 'Error parsing CSV')
                        reject(err)
                    }
                })
            } else if (['xlsx', 'xls'].includes(extension)) {
                const reader = new FileReader()
                reader.onload = (e) => {
                    const data = new Uint8Array(e.target.result)
                    const workbook = XLSX.read(data, { type: 'array', cellDates: true })
                    const firstSheetName = workbook.SheetNames[0]
                    const worksheet = workbook.Sheets[firstSheetName]
                    const jsonData = XLSX.utils.sheet_to_json(worksheet)
                    processData(jsonData)
                        .then(() => {
                            toast.success('Drivers assigned successfully')
                            this.handleHideBulkUploadModal()
                            this.setState({ refreshCounter: this.state.refreshCounter + 1 })
                            resolve()
                        })
                        .catch((err) => {
                            toast.error(err.message || 'Failed to assign drivers')
                            reject(err)
                        })
                }
                reader.onerror = (err) => {
                    toast.error('Error reading Excel file')
                    reject(err)
                }
                reader.readAsArrayBuffer(file)
            } else {
                const errorMsg = 'Unsupported file format. Please upload CSV or XLSX.'
                toast.error(errorMsg)
                reject(new Error(errorMsg))
            }
        })
    }

    render() {
        const props = this.props
        return (
            <>
                <ListingPage
                    menu={props.menu}
                    className="transporter-page"
                    title="Picklist Allocation"
                    refetchTableData={this.state.refreshCounter}
                    api={{
                        url: `${APG_GATEWAY_HOST}/seller-order-service/picklists`,
                        params: {
                            perPage: 5000,
                            storeID: 4,
                            vendorCode: '*',
                            pickupDate: `${this.state.pickupDate} 00:00:00..${this.state.pickupDate} 23:59:59`,
                        },
                        dataLength: this.state.data.length,
                        transform: (response) => {
                            if (response.data) {
                                // Add paging properties to avoid NaN in ListingPage pagination
                                response.data.count = response.data.length || 0
                                response.data.limit = response.data.length || 0
                                response.data.offset = 0

                                const mappedData = response.data.map((item) => {
                                    const slotFrom = item.reportSlotFrom ? moment(item.reportSlotFrom).format('HH:mm') : ''
                                    const slotTill = item.reportSlotTill ? moment(item.reportSlotTill).format('HH:mm') : ''

                                    return {
                                        id: item.id,
                                        vendorCode: item.vendorCode,
                                        vendorName: item.seller?.sellerName || '',
                                        storeCode: item.storeName || item.storeID,
                                        deliveryAddress: item.store?.address || '',
                                        pickupDate: item.pickupDate,
                                        handlingTime: slotFrom && slotTill ? `${slotFrom} - ${slotTill}` : '',
                                        assignedTransporter: item.transporter?.name || '',
                                        // Include original driver fields if they might be needed for tests or future-proofing
                                        driverID: item.transporter?.name || '',
                                        driverName: item.transporter?.name || '',
                                    }
                                })

                                // Avoid infinite loop by checking length or equality roughly
                                if (mappedData.length !== this.state.data.length) {
                                    // This is a side-effect, but needed for 'Select All' to work since ListingPage controls data
                                    setTimeout(() => {
                                        if (this.isMountedFlag) {
                                            this.setState({ data: mappedData })
                                        }
                                    }, 0)
                                }
                                return mappedData
                            }
                            return []
                        },
                    }}
                    emptyState={emptyState}
                    tableProperties={this.getTableProperties()}
                    filters={{
                        transformSubmit: (filters) => {
                            // Use 'd' for URL persistence to keep it simple and avoid encoding issues
                            return { d: filters.d || filters.pickupDate }
                        },
                        transformFilter: (filters) => {
                            // Use 'pickupDate' for actual API call with expanded range
                            const date = filters.d || filters.pickupDate
                            if (date) {
                                return {
                                    pickupDate: `${date} 00:00:00..${date} 23:59:59`
                                }
                            }
                            return {}
                        },
                        component: ({ onSubmit }) => (
                            <div className="filters-container">
                                <div className="filter-label">Pickup Date:</div>
                                <div className="date-picker-wrapper">
                                    <SingleDatePickerWrapper
                                        date={this.state.pickupDate}
                                        onDateChange={(date) => {
                                            this.setState({ pickupDate: date })
                                            onSubmit({ d: date })
                                        }}
                                        isOutsideRange={false}
                                        allowAllDates={true}
                                        placeholder="Select date"
                                    />
                                </div>
                            </div>
                        ),
                        showFiltersOnLoad: false,
                    }}
                    headerActions={() => (
                        <div className="header-actions-container">
                            <button
                                className="button download-template-btn"
                                onClick={this.handleDownloadTemplate}
                                title="Download Template"
                            >
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="20" viewBox="0 0 24 20">
                                    <g fill="none" fillRule="evenodd">
                                        <path d="M-3-6h30v30H-3z" opacity=".05" />
                                        <g stroke="#80959D">
                                            <path d="M1 15v4h22v-4M8 8l4.495 4L17 8M12.5 11.5V0" />
                                        </g>
                                    </g>
                                </svg>
                            </button>
                            <button className="primary button" onClick={this.handleShowBulkUploadModal}>
                                Bulk Upload
                            </button>
                            <button
                                className="primary button"
                                disabled={this.state.selectedRows.length === 0}
                                onClick={this.handleShowAssignTransporterModal}
                            >
                                Assign Transporter
                            </button>
                        </div>
                    )}
                    primaryKey="id"
                />
                <Toaster position="top-center" />
                {
                    this.state.showBulkUploadModal && (
                        <Popup
                            heading="Bulk Upload Transporter Allocation"
                            show={this.state.showBulkUploadModal}
                            close={this.handleHideBulkUploadModal}
                            className="transporter-upload-popup"
                        >
                            <div className="transporter-upload-container">
                                <Upload
                                    name="transporterAllocationUpload"
                                    accept=".csv, .xls, .xlsx, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                                    placeholder="Drop your file here or click to browse"
                                    uploadButtonText="Upload"
                                    cancelText="Cancel"
                                    onUpload={this.handleBulkUpload}
                                    validationStrings={{
                                        invalidFileType: 'Invalid file type. Please upload CSV or Excel file.',
                                    }}
                                    strings={{
                                        defaultMessage: 'Import Transporter Allocation',
                                        progressMessage: '',
                                        completionMessage: 'File uploaded successfully!',
                                    }}
                                />
                            </div>
                        </Popup>
                    )
                }
                {
                    this.state.showAssignTransporterModal && (
                        <Popup
                            heading="Transporter Allocation"
                            show={this.state.showAssignTransporterModal}
                            close={this.handleHideAssignTransporterModal}
                            className="assign-transporter-popup"
                        >
                            <div className="assign-modal-content">
                                <div className="assign-modal-form-group">
                                    <label className="assign-modal-label">
                                        Transporter ID
                                    </label>
                                    <select
                                        value={this.state.transporterId}
                                        onChange={this.handleTransporterIdChange}
                                        className="assign-modal-select"
                                    >
                                        <option value="">Select Transporter</option>
                                        {this.state.drivers.map(driver => (
                                            <option key={driver.driverID} value={driver.driverID}>
                                                {driver.driverName || driver.driverID}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="assign-modal-actions">
                                    <button
                                        className="primary button"
                                        onClick={this.handleSubmitAssignTransporter}
                                    >
                                        Submit
                                    </button>
                                    <button
                                        className="button assign-modal-cancel-btn"
                                        onClick={this.handleHideAssignTransporterModal}
                                    >
                                        Cancel
                                    </button>
                                </div>
                            </div>
                        </Popup>
                    )
                }
            </>
        )
    }
}
